import React, { useState, useEffect } from "react";
import magnifier from "../../../assets/img/magnifier_white.svg";
import cancelSearch from "../../../assets/img/cancel_search.svg";
import closeSearch from "../../../assets/img/close_search.svg";
import "./search.scss";

export function SearchWrapper({
  header,
  placeholder,
  enableTags = false,
  keyword,
  isCleanSearch,
  hasSearchValue,
  handleOnSearch,
  handleResetCleanSearch,
  onSetHasSearchValue,
}) {
  const [keywords, setKeywords] = useState([]);
  const [newKeyword, setNewKeyword] = useState(keyword || "");

  useEffect(() => {
    if (isCleanSearch && typeof handleResetCleanSearch === "function") {
      handleResetCleanSearch();
      setKeywords([]);
      setNewKeyword("");
    }
  }, [isCleanSearch]);

  const resetKeywordAndRefreshView = () => {
    if (hasSearchValue) {
      typeof handleResetCleanSearch === "function" && handleResetCleanSearch();
    }
  };

  const onCleanSearchKeywords = () => {
    setKeywords([]);
    setNewKeyword("");
    onResetKeywordAndRefreshView();
  };

  const onCloseKeyword = (index) => {
    delete keywords[index];
    setKeywords([...keywords.filter((i) => i !== index)]);
  };

  const onChangeSearchKeywords = (event) => {
    if (event.target.value.length) {
      setNewKeyword(event.target.value);
    } else {
      setNewKeyword("");
      onResetKeywordAndRefreshView();
    }
  };

  const onCreateKeyword = () => {
    setKeywords([...keywords, newKeyword]);
    setNewKeyword("");
  };

  const onPressKey = (event) => {
    event.key === "Enter" && onSearch();
  };

  const onSearch = () => {
    if (typeof handleOnSearch === "function") {
      const tmp = enableTags
        ? keywords.length && keywords.join(",")
        : newKeyword;

      tmp && handleOnSearch(tmp);
      onSetHasSearchValue(true);
    }
  };

  const onResetKeywordAndRefreshView = () => {
    setTimeout(() => {
      resetKeywordAndRefreshView();
    }, 200);
  };

  return (
    <>
      <div data-testid="search_container" className="search_container">
        <h3 data-testid="search__title">{header}</h3>
        <div className="search_content">
          <div className="search_content__input">
            {keywords.map((key, i) => (
              <div className="search_content__input_keyword" key={i}>
                <span>{key}</span>
                <img
                  alt="Close"
                  src={closeSearch}
                  onClick={() => onCloseKeyword(i)}
                />
              </div>
            ))}
            <div className="search_content__input_value">
              <input
                data-testid="search__input"
                id="search__input"
                placeholder={placeholder}
                value={newKeyword}
                onChange={(event) => onChangeSearchKeywords(event)}
                onKeyPress={(event) => onPressKey(event)}
              />
              {enableTags && newKeyword.length > 0 && (
                <div
                  className="search_content__keyword_create"
                  onClick={onCreateKeyword}
                >
                  <span>Create "{newKeyword}"</span>
                </div>
              )}
            </div>
          </div>
          {(Boolean(keywords.length) || newKeyword) && (
            <div
              data-testid="search__close_button"
              className="search_content__close"
              onClick={onCleanSearchKeywords}
            >
              <img alt="Close" src={cancelSearch} />
            </div>
          )}
          <div
            className="search_content__button"
            data-testid="search__button"
            onClick={onSearch}
          >
            <img alt="Search" src={magnifier} />
          </div>
        </div>
      </div>
    </>
  );
}
